"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousOrderLineVersion = void 0;
const getPreviousOrderLineVersion = (versions) => {
    if (!versions || versions.length === 0)
        return null;
    if (versions.length === 1)
        return null; // if there is only 1 version tehre is no previous version
    // the latest version is the one with the newest created_at date
    return versions.sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    })[1];
};
exports.getPreviousOrderLineVersion = getPreviousOrderLineVersion;
